import axios from "axios";
import { Constants } from "../utils/Constants";

export function get(id) {
    return axios.get(`${Constants.baseUrl}/notificacao/${id}`);
}

export function getDataTable(events) {
    return axios.post(`${Constants.baseUrl}/notificacao/list`, events);
}

export function verificarNotificacoes() {
    return axios.get(`${Constants.baseUrl}/notificacao`);
}

export function marcarLido(id) {
    return axios.get(`${Constants.baseUrl}/notificacao/${id}/lido`);
}
